// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__GdIBK","link":"HeaderSimple_link__mQ8Y0"};